import type { PaymentsProperty } from './Types/PaymentsProperty';

export enum PaymentsActions {
    LOAD_PAYMENTS_PROPERTIES = 'PAYMENTS_LOAD_PROPERTIES',
    SET_PAYMENTS_PROPERTIES = 'PAYMENTS_SET_PROPERTIES',
    SET_PAYMENTS_PROPERTIES_ERROR_STATE = 'PAYMENTS_SET_PROPERTIES_ERROR_STATE',
}

interface LoadPaymentsPropertiesAction {
    type: typeof PaymentsActions.LOAD_PAYMENTS_PROPERTIES;
}

interface SetPaymentsPropertiesAction {
    type: typeof PaymentsActions.SET_PAYMENTS_PROPERTIES;
    payload: PaymentsProperty[];
}

interface SetPaymentsPropertiesErrorStateAction {
    type: typeof PaymentsActions.SET_PAYMENTS_PROPERTIES_ERROR_STATE;
    payload: {
        errorMessage: string;
        secondaryMessage?: string;
    };
}

export type PaymentsActionTypes =
    | LoadPaymentsPropertiesAction
    | SetPaymentsPropertiesAction
    | SetPaymentsPropertiesErrorStateAction;
